export const assignPositions = (data) => {
    if (!data.length) {
        return [];
    }

    let position = 1;

    // sort just incase
    const sortedData = data.toSorted((a, b) => b.totalVotes - a.totalVotes);

    return sortedData.map((item, index) => {
        if (!item.eligible) {
            position = null;
        } else {
            position =
                index +
                1 -
                data.slice(0, index).filter((i) => !i.eligible).length;
        }
        return { ...item, position };
    });
};
